import { render, staticRenderFns } from "./RegisterOasys.vue?vue&type=template&id=37d4edb4&scoped=true"
import script from "./RegisterOasys.vue?vue&type=script&lang=js"
export * from "./RegisterOasys.vue?vue&type=script&lang=js"
import style0 from "./RegisterOasys.vue?vue&type=style&index=0&id=37d4edb4&prod&scoped=true&lang=css"
import style1 from "./RegisterOasys.vue?vue&type=style&index=1&id=37d4edb4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37d4edb4",
  null
  
)

export default component.exports